import { lazy } from "react";

const LearningTrue = lazy(() => import("@views/Definition/LearningTrue"))
const Sum = lazy(() => import("@views/Definition/Sum"))
const AmountDetails = lazy(() => import("@views/Definition/AmountDetails"))
const CreditCalculation = lazy(() => import("@views/Definition/CreditCalculation"))
const CheckDefinition = lazy(() => import("@views/Definition/CheckDefinition"))

const DefinitionRoutes = [
    {
        path: 'definition/learning-true',
        element: <LearningTrue />
    },
    {
        path: 'definition/sum',
        element: <Sum />
    },
    {
        path: 'definition/amount-details',
        element: <AmountDetails />
    },
    {
        path: 'definition/credit-calculation',
        element: <CreditCalculation />
    },
    {
        path: 'definition/check-definition',
        element: <CheckDefinition />,
        meta: {
            publicRoute: true,
            layout: "blank"
        }
    },
]

export default DefinitionRoutes
